import { render } from "./UpcomingBookingLoader.vue?vue&type=template&id=3b4c4d6b"
import script from "./UpcomingBookingLoader.vue?vue&type=script&lang=js"
export * from "./UpcomingBookingLoader.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__